<main>
    <div class="d-grid gap-4">
        <div class="eventType-head">
            <div class="d-flex align-items-center gap-3" style="cursor: pointer;" (click)="goBack()">
                <i class="fas fa-arrow-left back-icon"></i>
                <div class="eventType-text">
                    FAQ Management
                </div>
            </div>
            <div class="buttonContainer">
                <div class="search-container">
                    <div class="search-icon">
                        <img src="assets/icons/side-bar/search-normal.svg" alt="search"
                            style="width: 18px; height: 18px;" />
                    </div>
                    <input type="text" placeholder="Search here..." class="search-input" [(ngModel)]="search"
                        (input)="updateSearch(search)" (keyup.enter)="applyFilter()" autocomplete="off" />
                </div>
            </div>
        </div>

        <!-- Section Tabs -->
        <div class="faq-section-tabs">
            <button
                *ngFor="let section of sections"
                class="section-tab"
                [class.active]="activeSection === section.audienceType"
                (click)="setSection(section.audienceType)">
                {{ section.label }}
            </button>
        </div>

        <div class="faq-card">
            <div class="d-flex gap-3 align-items-center justify-content-between">
                <div class="w-100">
                    <app-input context="Normal" class="form-item" label="Select FAQ category"
                        placeholder="Select FAQ category" type="select" [control]="selectedCategoryControl"
                        [options]="FAQCategoryOptions" [showAddNew]="AdminMode ? true : false"
                        [addNewText]="AdminMode ? 'Add new category' : ''" (addNewClicked)="openAddCategory()"
                        [customErrorMessages]="customErrorMessages">
                    </app-input>
                </div>
            </div>
        </div>

        <!-- Main FAQ Section - Only show when category is selected -->
        <div class="faq-card pb-3" *ngIf="selectedCategory">
            <div class="d-flex align-items-center justify-content-between">
                <div class="header-text">{{ getCategoryTitle() }}</div>
                <app-button *ngIf="AdminMode" [label]="'Add FAQ'" [minWidth]="'8rem'" (clicked)="toggleAddFAQ()"
                    [bgcolor]="'rgba(0, 0, 0, 0.15)'" [class.disabled]="!selectedCategory">
                </app-button>
            </div>

            <!-- Add FAQ Form -->
            <div class="faq-section" *ngIf="showAddForm">
                <div class="w-100">
                    <div class="mb-3">
                        <label class="form-label">Question</label>
                        <input type="text" class="form-control" [(ngModel)]="newFAQ.question"
                            placeholder="Type your question here">
                    </div>
                    <div class="mb-3">
                        <label class="form-label">Answer</label>
                        <input type="text" class="form-control" [(ngModel)]="newFAQ.answer"
                            placeholder="Type your answer here">
                    </div>
                </div>
                <div class="button-section">
                    <button class="custom-btn" (click)="saveNewFAQ()"
                        [class.disabled]="isLoading || !newFAQ.question.trim() || !newFAQ.answer.trim()">Save</button>
                    <button class="custom-btn-outline" (click)="cancelAddFAQ()">Cancel</button>
                </div>
            </div>

            <div class="faq-list mt-3" *ngIf="hasFAQsInSelectedCategory" cdkDropList (cdkDropListDropped)="drop($event)"
                [cdkDropListData]="currentCategoryFAQs">
                <div class="faq-item" *ngFor="let faq of currentCategoryFAQs; let i = index" cdkDrag
                    [class.edit-mode]="editingId === faq.id" [cdkDragData]="faq">
                    <div class="d-flex align-items-start">
                        <div class="flex-grow-1">
                            <div *ngIf="editingId === faq.id; else viewMode"
                                class="d-flex justify-content-between gap-4">
                                <div class="w-100">
                                    <div class="mb-3">
                                        <label class="form-label">Question</label>
                                        <input type="text" class="form-control" [(ngModel)]="editingFAQ.question">
                                    </div>
                                    <div class="mb-3">
                                        <label class="form-label">Answer</label>
                                        <input type="text" class="form-control" [(ngModel)]="editingFAQ.answer">
                                    </div>
                                </div>
                                <div class="button-section">
                                    <button class="custom-btn" (click)="saveEdit()"
                                        [class.disabled]="isLoading || !editingFAQ.question || !editingFAQ.answer">Save</button>
                                    <button class="custom-btn-outline" (click)="cancelEdit()">Cancel</button>
                                </div>
                            </div>

                            <ng-template #viewMode>
                                <div class="d-flex align-items-center justify-content-between">
                                    <div>
                                        <div class="faq-question">{{ faq.question }}</div>
                                        <div class="faq-answer">{{ faq.answer }}</div>
                                        <div class="faq-updated">{{ faq?.lastUpdatedDisplay }}</div>
                                    </div>

                                    <div class="faq-actions">
                                        <button class="action-btn" (click)="moveUp(i)" [class.disabled]="i === 0"
                                            title="Move Up">
                                            <i class="fas fa-arrow-up"></i>
                                        </button>
                                        <button class="action-btn" (click)="moveDown(i)"
                                            [class.disabled]="i === currentCategoryFAQs.length - 1" title="Move Down">
                                            <i class="fas fa-arrow-down"></i>
                                        </button>
                                        <button *ngIf="AdminMode" class="edit-btn" (click)="editFAQ(faq)" title="Edit">
                                            <img class="action-button" src="assets/images/Buttons/edit-button.svg"
                                                alt="Edit" />
                                        </button>
                                        <button *ngIf="AdminMode" class="delete-btn" (click)="deleteFAQ(faq)"
                                            title="Delete">
                                            <img class="action-button" src="assets/images/Buttons/delete-button.svg"
                                                alt="Delete" />
                                        </button>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Empty State -->
            <div class="empty-state" *ngIf="!showAddForm && !hasFAQsInSelectedCategory">
                <i class="far fa-file-alt"></i>
                <h4>No FAQs yet</h4>
                <p>Click "Add FAQ" to create your first FAQ for this category.</p>
            </div>
        </div>

        <!-- When no category is selected -->
        <div class="faq-card pb-3" *ngIf="!selectedCategory">
            <div class="empty-state">
                <i class="far fa-file-alt"></i>
                <h4>Select a Category</h4>
                <p>Please select an FAQ category to view or manage FAQs.</p>
            </div>
        </div>
    </div>
</main>
